import _styled from "@emotion/styled-base";
var _excluded = ["name", "items", "selectedItems", "toValue", "toLabel", "allowMultipleSelections", "columns", "selectableSize"];

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import { css } from "@emotion/core";
import * as React from "react";
import { space, width } from "styled-system";
import Box from "../Box";
import { emRhythm } from "../css";
import SelectableItem from "./SelectableItem";
import { jsx as ___EmotionJSX } from "@emotion/core";

function idAsValue(item) {
  return item ? item.id : null;
}

function displayAsLabel(item) {
  return item ? item.display : "";
}

var SelectableBox = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "onSelection";
  },
  target: "et85bl90"
})(space, width);

var StyledSelectable = /*#__PURE__*/_styled("div", {
  target: "et85bl91"
})( /*#__PURE__*/css("display:flex;justify-content:flex-start;flex-wrap:wrap;margin:0 ", emRhythm(-0.25), ";"), space, width);

var StyledSelectableWrapper = /*#__PURE__*/_styled("div", {
  target: "et85bl92"
})( /*#__PURE__*/css("margin-bottom:", emRhythm(0.5), ";padding:0 ", emRhythm(0.25), ";"), space, width);

var Selectable = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Selectable, _React$Component);

  function Selectable() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onInputChange = function (item, event) {
      var _ref = event.target,
          checked = _ref.checked,
          name = _ref.name;
      var _this$props = _this.props,
          onSelection = _this$props.onSelection,
          allowMultipleSelections = _this$props.allowMultipleSelections,
          selectedItems = _this$props.selectedItems,
          toValue = _this$props.toValue;
      var newValues = selectedItems;

      if (allowMultipleSelections) {
        var foundIndex = selectedItems.findIndex(function (value) {
          return toValue(value) === toValue(item);
        });

        if (checked && foundIndex === -1) {
          newValues = [].concat(selectedItems, [item]);
        }

        if (!checked && foundIndex !== -1) {
          newValues = Array.from(selectedItems);
          newValues.splice(foundIndex, 1);
        }
      } else if (checked) {
        newValues = [item];
      } else {
        newValues = [];
      }

      if (onSelection !== undefined) onSelection(newValues, name);
    };

    return _this;
  }

  var _proto = Selectable.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        name = _this$props2.name,
        items = _this$props2.items,
        selectedItems = _this$props2.selectedItems,
        toValue = _this$props2.toValue,
        toLabel = _this$props2.toLabel,
        allowMultipleSelections = _this$props2.allowMultipleSelections,
        columns = _this$props2.columns,
        selectableSize = _this$props2.selectableSize,
        props = _objectWithoutPropertiesLoose(_this$props2, _excluded);

    var itemIdPrefix = (props.id || name) + "-item";
    return ___EmotionJSX(SelectableBox, props, ___EmotionJSX(StyledSelectable, null, items.map(function (item, index) {
      return ___EmotionJSX(StyledSelectableWrapper, {
        width: 1 / columns,
        key: (toValue(item) || item.display) + "-wrapper"
      }, ___EmotionJSX(SelectableItem, {
        item: item,
        id: itemIdPrefix + "-" + index,
        name: name,
        type: allowMultipleSelections ? "checkbox" : "radio",
        onChange: _this2.onInputChange,
        selected: selectedItems.find(function (value) {
          return toValue(value) === toValue(item);
        }),
        toValue: toValue,
        toLabel: toLabel,
        width: 1,
        size: selectableSize
      }));
    })));
  };

  return Selectable;
}(React.Component);

Selectable.defaultProps = {
  columns: 1,
  selectedItems: [],
  toLabel: displayAsLabel,
  toValue: idAsValue,
  onSelection: undefined,
  allowMultipleSelections: true,
  selectableSize: "md"
};
export default Selectable;